module.exports = __webpack_public_path__ + "img/CleverSaleVertical.12f83cbe.png";